import http from "./http";
import md5 from "md5";

const { REACT_APP_API_RETRIES, REACT_APP_BASE_URL } = process.env;
const RETRIES = 1;

const cache = {};
const BASE_URL = REACT_APP_BASE_URL || `${window.location.origin}/api`;

const callAPI = (cacheKey, func) => {
  if (!cacheKey) {
    return func();
  }

  if (!cache[cacheKey]) {
    cache[cacheKey] = func();
  }

  return cache[cacheKey];
};

export const api = (method, func, url, payload, cacheable = false) => {
  url = BASE_URL + url;
  const cacheKey = cacheable
    ? md5(`${method}-${url}-${payload ? JSON.stringify(payload) : ""}`)
    : "";

  return callAPI(cacheKey, async () => {
    let retries = 0;
    let error;

    while (retries < RETRIES) {
      try {
        const { data } = await func(url, payload);
        return data;
      } catch (e) {
        cacheKey && delete cache[cacheKey];
        retries++;
        error = e;
      }
    }
    if (error) {
      throw error;
    }
  });
};

export const apiGet = (url, cacheable = false) =>
  api("GET", http.get, url, undefined, cacheable);

export const apiPost = (url, payload, cacheable = false) =>
  api("POST", http.post, url, payload, cacheable);

export const apiPut = (url, payload, cacheable = false) =>
  api("PUT", http.put, url, payload, cacheable);

export const apiDelete = (url, payload, cacheable = false) =>
  api("DELETE", http.delete, url, payload, cacheable);

export const urlCheck = async (url) => {
  try {
    return await http.head(url);
  } catch {
    return null;
  }
};

export default callAPI;
